import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container, Row, Col, Form } from "react-bootstrap";
import Preloader from "../../../shared/PreLoaders";
import { Authorization } from "../../../Context/Authorization";
const VFCProfile = () => {
  const [vfcData, setVfcData] = useState([]);
  const [ranges, setRanges] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [circles, setCircles] = useState([]);
  const [selectedRange, setSelectedRange] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedCircle, setSelectedCircle] = useState("");
  const [selectedVfc, setSelectedVfc] = useState("");
  const [vfcProfileData, setVfcProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showProfile, setShowProfile] = useState(false);
  const Api = process.env.REACT_APP_API;
  const [error, setError] = useState(""); // New state for error handling

  useEffect(() => {
    const fetchCircle = async () => {
      setLoading(true);
      setError(""); // Reset error state
      try {
        const config = Authorization();
        const response = await axios.get(`${Api}/api/circles`, config);
        setCircles(response.data);
      } catch (err) {
        setError("Failed to fetch Circles. Please try again.");
        console.error("Error fetching circles", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCircle();
  }, []);

  // Fetch Divisions
  useEffect(() => {
    if (!selectedCircle) return;

    const fetchDivision = async () => {
      setLoading(true);
      setError("");
      try {
        const config = Authorization();
        const response = await axios.post(
          `${Api}/api/divisions/divisions-by-circle`,
          { circleId: selectedCircle },
          config
        );
        setDivisions(response.data);
      } catch (err) {
        setError("Failed to fetch Divisions. Please try again.");
        console.error("Error fetching divisions", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDivision();
  }, [selectedCircle]);

  // Fetch Ranges
  useEffect(() => {
    if (!selectedDivision) return;

    const fetchRange = async () => {
      setLoading(true);
      setError("");
      try {
        const config = Authorization();
        const response = await axios.post(
          `${Api}/api/ranges/ranges-by-division`,
          { divisionId: selectedDivision },
          config
        );
        setRanges(response.data);
      } catch (err) {
        setError("Failed to fetch Ranges. Please try again.");
        console.error("Error fetching ranges", err);
      } finally {
        setLoading(false);
      }
    };

    fetchRange();
  }, [selectedDivision]);

  // Fetch VFCs
  useEffect(() => {
    if (!selectedRange) return;

    const fetchVfc = async () => {
      setLoading(true);
      setError("");
      try {
        const config = Authorization();
        const response = await axios.post(
          `${Api}/api/vfcs/vfcs-by-range`,
          { rangeId: selectedRange },
          config
        );
        setVfcData(response.data.vfcs);
      } catch (err) {
        setError("Failed to fetch VFC data. Please try again.");
        console.error("Error fetching VFC data", err);
      } finally {
        setLoading(false);
      }
    };

    fetchVfc();
  }, [selectedRange]);

  // Fetch VFC Profile
  const handleSelectVfc = async (e) => {
    setSelectedVfc(e.target.value);
    setLoading(true);
    setError("");
    try {
      const config = Authorization();
      const response = await axios.post(
        `${Api}/api/vfcs/getVfcProfileByVfcId`,
        { id: e.target.value },
        config
      );
      setVfcProfileData(response.data.vfc || null);
    } catch (error) {
      setError("Failed to fetch VFC profile. Please try again.");
      console.error("Error fetching VFC profile", error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewProfile = (e) => {
    e.preventDefault();
    setShowProfile(!!selectedVfc);
  };

  return (
    <div>
      <Preloader loading={loading} />
      <div className="page-header">
        <h3 className="page-title"> VFC Profile </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              VFC Profile
            </li>
          </ol>
        </nav>
      </div>
      <Container>
        <div className="col-md-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <Form>
                <Row>
                  <Col xs={3}>
                    <Form.Group controlId="Circle" className="mb-3">
                      <Form.Label>Circle</Form.Label>
                      <Form.Control
                        as="select"
                        value={selectedCircle}
                        onChange={(e) => setSelectedCircle(e.target.value)}
                      >
                        <option value="">Select Circle</option>
                        {circles.map((circle) => (
                          <option key={circle._id} value={circle._id}>
                            {circle.circleName}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col xs={3}>
                    <Form.Group controlId="Division" className="mb-3">
                      <Form.Label>Division</Form.Label>
                      <Form.Control
                        as="select"
                        value={selectedDivision}
                        onChange={(e) => setSelectedDivision(e.target.value)}
                        disabled={!selectedCircle}
                      >
                        <option value="">Select Division</option>
                        {divisions.map((division) => (
                          <option key={division._id} value={division._id}>
                            {division.divisionName}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col xs={3}>
                    <Form.Group controlId="Range" className="mb-3">
                      <Form.Label>Range</Form.Label>
                      <Form.Control
                        as="select"
                        value={selectedRange}
                        onChange={(e) => setSelectedRange(e.target.value)}
                        disabled={!selectedDivision}
                      >
                        <option value="">Select Range</option>
                        {ranges.map((range) => (
                          <option key={range._id} value={range._id}>
                            {range.rangeName}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col xs={3}>
                    <Form.Group controlId="VFC" className="mb-3">
                      <Form.Label>VFC</Form.Label>
                      <Form.Control
                        as="select"
                        value={selectedVfc}
                        onChange={handleSelectVfc}
                        disabled={!selectedRange}
                      >
                        <option value="">Select VFC</option>
                        {vfcData.map((vfc) => (
                          <option key={vfc._id} value={vfc._id}>
                            {vfc.vfcName}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                <button
                  type="button"
                  className="btn btn-outline-primary btn-icon-text  "
                  onClick={handleViewProfile}
                >
                  <i className="mdi mdi-file-check btn-icon-prepend"></i>
                  Submit
                </button>
              </Form>
              {error && (
                <div className="alert alert-danger mt-3" role="alert">
                  {error}
                </div>
              )}
            </div>
          </div>
        </div>

        {showProfile ? (
          vfcProfileData ? (
            <>
              <div className="card">
                <div className="card-body">
                  <div className="row icons-list">
                    <div className="table-responsive">
                      <table className="table">
                        <tbody>
                          <tr>
                            <td>1.</td>
                            <td>Formation of VFC</td>
                            <td>: {vfcProfileData.dateOfEstablishment}</td>
                          </tr>
                          <tr>
                            <td>2.</td>
                            <td>Registration of VFC</td>
                            <td>: {vfcProfileData.dateOfEstablishment}</td>
                          </tr>
                          <tr>
                            <td>3.</td>
                            <td>Registration No</td>
                            <td>: {vfcProfileData.registrationNo}</td>
                          </tr>
                          <tr>
                            <td>4.</td>
                            <td>VFC Account No</td>
                            <td>: {vfcProfileData.accountNumber}</td>
                          </tr>
                          <tr>
                            <td>5.</td>
                            <td>Total Family</td>
                            <td>: {vfcProfileData.totalFamily}</td>
                          </tr>
                          <tr>
                            <td>6.</td>
                            <td>Total Population</td>
                            <td>: {vfcProfileData.totalPopulation}</td>
                          </tr>
                          <tr>
                            <td>7.</td>
                            <td>VFC Family</td>
                            <td>: {vfcProfileData.vfcFamily}</td>
                          </tr>
                          <tr>
                            <td>8.</td>
                            <td>Total SHG's</td>
                            <td>: {vfcProfileData.totalSHG}</td>
                          </tr>
                          <tr>
                            <td>9.</td>
                            <td>Total SHG Members</td>
                            <td>: {vfcProfileData.totalSHGMembers}</td>
                          </tr>
                          <tr>
                            <td>10.</td>
                            <td>Project Contripution</td>
                            <td>: 6,00,500/-</td>
                          </tr>
                          <tr>
                            <td>11.</td>
                            <td>Enrty Point Activities</td>
                            <td>: 60,000/-</td>
                          </tr>
                          <tr>
                            <td>12.</td>
                            <td>Corpus Fund</td>
                            <td>: 10,11,000</td>
                          </tr>
                          <tr>
                            <td>13.</td>
                            <td>Total Subscription</td>
                            <td>: 35,000/-</td>
                          </tr>
                          <tr>
                            <td>14.</td>
                            <td>Total Loan Distributed</td>
                            <td>: {vfcProfileData.totalLoanAmount}/-</td>
                          </tr>
                          <tr>
                            <td>15.</td>
                            <td>Loan Received</td>
                            <td>: {vfcProfileData.totalAmountPaid}/-</td>
                          </tr>
                          <tr>
                            <td>16.</td>
                            <td>Recovery Persentage</td>
                            <td>: {vfcProfileData.recoveryPercentage}%</td>
                          </tr>
                          <tr>
                            <td>17.</td>
                            <td>
                              Bank Balance as on {vfcProfileData.auditDate}{" "}
                            </td>
                            <td>: {vfcProfileData.auditBalance}/-</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn btn-outline-info btn-icon-text"
                  >
                    Print
                    <i className="mdi mdi-printer btn-icon-append"></i>
                  </button>
                </div>
              </div>
            </>
          ) : (
            <p>No profile data available for the selected VFC.</p>
          )
        ) : (
          <p>Please Select all Required Select Box</p>
        )}
      </Container>
    </div>
  );
};

export default VFCProfile;
